module.exports = __webpack_public_path__ + "img/icon-lotto-result.a2b42684.png";